import 'angular:locale/data:to';
import 'angular:locale/data:en';
import 'angular:locale/data:es';
import './projects/skudo/src/polyfills.ts';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
